import {padNum, texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemGoldenCoin extends Item {
    constructor() {
        super(definitions.ITEM_ID.GOLDEN_COIN, texture("prop_gold_coin_01"));
    }

    init() {
        super.init();

        let frames = [];
        for (let i = 0; i < 6; ++i) {
            frames[i] = texture("prop_gold_coin_" + padNum(i+1, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "idle");
        
        this.addViewWithMovieClip(sequence, "idle");

        this._playIdleAnimation();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(0, 0));
    }

    _playIdleAnimation() {
        this._view.animationSpeed = 10;
        this._view.gotoAndPlay("idle", true);
    }
}